import { createAction } from "redux-actions"

export const showMessage = createAction("showMessage");
export const showTermsAndConditions = createAction("showTermsAndConditions");
